export default __webpack_public_path__ + "static/media/status-not-sent-icon.163941ae.svg";